import { render, staticRenderFns } from "./PurchaseRatioInput.vue?vue&type=template&id=86c47df0&"
import script from "./PurchaseRatioInput.vue?vue&type=script&lang=js&"
export * from "./PurchaseRatioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports